































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import indexService from '@/service/index.service';
import 'swiper/css/swiper.css';
const Swiper = require('swiper').default;
const guestData = require('./jinrong-jiabin.json');
// import Swiper from "swiper";
@Component
export default class Index extends Vue {
  zhiboUrl: any = ['http://www.nbd.com.cn/corp/AiTv/index.html', 'http://www.nbd.com.cn/corp/nbd_live/dist/index.html#/?id=1385', 'http://www.nbd.com.cn/corp/nbd_live/dist/index.html#/?id=1384'];
  dialogShow: boolean = false;
  bandanList: any = [require('@/assets/bangdan1.png'), require('@/assets/bangdan2.png'), require('@/assets/bangdan3.png'), require('@/assets/bangdan4.png')];
  bannerUrl: any = ['http://www.nbd.com.cn/corp/20211108jdjzb/index.html', 'http://www.nbd.com.cn/corp/20211108jdjzb/gongmu.html', 'http://www.nbd.com.cn/corp/20211108jdjzb/touzijigouzb.html', 'http://www.nbd.com.cn/corp/20211108jdjzb/zhengquanzb.html'];
  mySwiper: any = {};
  topNavHeight: number = 0;
  activeNav: string = 'hdbj';
  liveTime: string = '';
  scrollShowHeight: number = 0;
  center: any = { lng: 0, lat: 0 };
  zoom: number = 3;
  offsetTopObj: any = {
    hdbj: 0,
    zbjb: 0,
    hdyc: 0,
    zbgk: 0,
    xwdt: 0,
    zbfb: 0,
    hddz: 0,
    zzjg: 0
  };
  newsList: any[] = [];
  scrollerEl!: HTMLElement;
  articles: any[] = [];
  imgsList: any[] = [];
  guests: any = {
    jinrong: [],
    chuangtou: [],
    ziben: []
  };
  showToast: boolean = false;
  timer: any;
  containerTop: number = 0;
  jxfbStr: string = '';
  isJxfb: boolean = false;
  orgList: any[] = [
    {
      title: '主办单位',
      desc: '每日经济新闻'
    },
    {
      title: '智略平台',
      desc: '每经智库   每经研究院   每经品牌价值研究院'
    },
    {
      title: '学术支持',
      desc: '清华大学中国企业研究中心   天相财富'
    },
    {
      title: '数据支持',
      desc: '清博智能   私募排排网   场景汇'
    },
    {
      title: '合作媒体',
      desc: '中新经纬   21世纪经济报道   中国经营报   经济观察报   南方周末   界面   搜狐   凤凰网财经   和讯   雪球   金融界   清博智能   创业邦   成功营销   创业黑马'
    },
    {
      title: '直播平台',
      desc: '每经AI电视台   东方财富浪客   微博   视频号   今日头条   抖音   知乎   百家号    活动行'
    },
    {
      title: '每经全媒体',
      desc: '每日经济新闻   每经网   每经APP   每日经济新闻官方微博   每日经济新闻官方微信   每日经济新闻官方视频号   每经头条   每经牛眼   理财不二牛   道达号   镁刻地产   NBD汽车   每经影视   粉巷财经   城市进化论   N小黑财经'
    }
  ];
  created() {
    if (Date.now() < 1602763800000) {
      this.jxfbStr = '10月15-16日 敬请期待';
    } else {
      //   this.jxfbStr = "点击查看";
      this.jxfbStr = '11月08日  敬请期待';
      //   this.isJxfb = true;
    }
    this.getGuests();
  }
  activated() {
    this.readScrollTop();
  }
  mounted() {
    this.$nextTick(() => {
      this.scrollerEl = <HTMLElement>this.$refs.scroller;
      this.readScrollTop();
      let topNavEl = <HTMLElement>this.$refs.topNav;
      this.scrollShowHeight = parseFloat(getComputedStyle(this.scrollerEl).height);
      this.topNavHeight = parseFloat(getComputedStyle(<HTMLElement>topNavEl).height) + parseFloat(getComputedStyle(<HTMLElement>topNavEl).paddingTop) + parseFloat(getComputedStyle(<HTMLElement>topNavEl).paddingBottom);
      this.initSwiper();
      this.scrollerEl.addEventListener('scroll', this.changeActiveNav);

      indexService.getNews().then(d => {
        console.log(d.data);
        this.newsList = this.newsList.concat(d.data);
      });
    });
  }
  handler({ BMap, map }: any) {
    this.zoom = 16;
    this.center.lng = 114.020502;
    this.center.lat = 22.536165;
  }
  goJxfb() {
    if (this.isJxfb) {
      location.href = 'http://www.nbd.com.cn/corp/2020kbbh5/index.html';
    }
  }
  readScrollTop() {
    setTimeout(() => {
      let scrollTop = sessionStorage.getItem('scrollTop');
      console.log(scrollTop);
      this.scrollerEl.scrollTo(0, Number(scrollTop));
    }, 25);
  }
  getGuests() {
    console.log(guestData);
    // indexService.getGuests().then(res => {
    //   let { data } = res;
    //   data = data.slice(data.indexOf('{'));
    //   let guestJson;
    //   eval('guestJson=' + data + '');
    this.guests = guestData;
    // });
  }
  getImgs() {
    indexService.getImgs().then(res => {
      this.imgsList = res.data.data.images;
      setTimeout(() => {
        this.initSwiper();
        this.calcOffsetTop();
      }, 25);
    });
  }
  // getArticles() {
  //   indexService.getAritcles().then(res => {
  //     this.articles = res.data;
  //     setTimeout(() => {
  //       this.calcOffsetTop();
  //     }, 25);
  //   });
  // }
  calcOffsetTop() {
    // this.offsetTopObj.hdbj = (<HTMLElement>(
    //     document.querySelector("#hdbj")
    // )).offsetTop;
    this.offsetTopObj.hdbj = (<HTMLElement>document.querySelector('#hdbj')).offsetTop;
    this.offsetTopObj.zbjb = (<HTMLElement>document.querySelector('#zbjb')).offsetTop;
    this.offsetTopObj.hdyc = (<HTMLElement>document.querySelector('#hdyc')).offsetTop;
    this.offsetTopObj.zbgk = (<HTMLElement>document.querySelector('#zbgk')).offsetTop;
    this.offsetTopObj.xwdt = (<HTMLElement>document.querySelector('#xwdt')).offsetTop;
    this.offsetTopObj.zbfb = (<HTMLElement>document.querySelector('#zbfb')).offsetTop;
    this.offsetTopObj.hddz = (<HTMLElement>document.querySelector('#hddz')).offsetTop;
    this.offsetTopObj.zzjg = (<HTMLElement>document.querySelector('#zzjg')).offsetTop;
    // this.offsetTopObj.jctj = (<HTMLElement>(
    //     document.querySelector("#jctj")
    // )).offsetTop;
    // this.offsetTopObj.wjhg = (<HTMLElement>(
    //     document.querySelector("#wjhg")
    // )).offsetTop;
  }

  changeActiveNav() {
    // console.log(111111111)
    let scrollTop = this.scrollerEl.scrollTop;
    let h = this.scrollShowHeight + this.topNavHeight;
    if (scrollTop + h < 680) {
      this.activeNav = 'hdbj';
      return;
    }
    if (scrollTop + h >= this.offsetTopObj.zzjg + this.containerTop) {
      this.activeNav = 'zzjg';
    } else if (scrollTop + h >= this.offsetTopObj.hddz + this.containerTop) {
      // this.activeNav = 'hddz';
    } else if (scrollTop + h >= this.offsetTopObj.zbfb + this.containerTop) {
      this.activeNav = 'zbfb';
    } else if (scrollTop + h >= this.offsetTopObj.xwdt + this.containerTop) {
      this.activeNav = 'xwdt';
    } else if (scrollTop + h >= this.offsetTopObj.zbgk + this.containerTop) {
      this.activeNav = 'zbgk';
    } else if (scrollTop + h >= this.offsetTopObj.hdyc + this.containerTop) {
      this.activeNav = 'hdyc';
    } else if (scrollTop + h >= this.offsetTopObj.zbjb + this.containerTop) {
      this.activeNav = 'zbjb';
    } else if (scrollTop + h >= this.offsetTopObj.hdbj + this.containerTop) {
      // this.activeNav = 'hdbj';
    }
  }
  go(id: string): void {
    console.log(id, 'id');

    var element = <HTMLElement>document.getElementById(id);
    element.scrollIntoView();
    // element.scrollIntoView(false);
    // element.scrollIntoView({ block: "end" });
    // element.scrollIntoView({
    //   behavior: "smooth",
    //   block: "end",
    //   inline: "nearest",
    // });

    // let el = <HTMLElement>this.$refs[id];
    // this.scrollerEl.scrollTo(0, el.offsetTop - this.topNavHeight);

    setTimeout(() => {
      this.activeNav = id;
    }, 25);
  }
  initSwiper(): void {
    var mySwiper = new Swiper('.swiper-container', {
      autoplay: true,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      pagination: {
        el: '.swiper-pagination'
      }
    });
    this.mySwiper = mySwiper;
    setTimeout(() => {
      this.containerTop = (<HTMLElement>document.querySelector('.container')).offsetTop;
      this.calcOffsetTop();
    }, 25);
  }
  goYc(path: string) {
    sessionStorage.setItem('scrollTop', this.scrollerEl.scrollTop.toString());
    this.$router.push(path);
  }
  goZb(url: string) {
    // console.log(this.mySwiper.activeIndex);
    let a = this.mySwiper.activeIndex;
    var b;
    if (a == 1 || a == 4) {
      b = '11月8日14:00-18:35';
      if (Date.now() - Date.parse('2021/11/08 14:00:00') > 0) {
        window.open(this.zhiboUrl[0]);
        return;
      }
    } else if (a == 2) {
      b = '11月8日9:30-11:30';
      window.open(this.zhiboUrl[1]);
      return;
    } else if (a == 3 || a == 0) {
      b = '11月8日9:30-11:55';
      window.open(this.zhiboUrl[2]);
      return;
    }

    // location.href = url;
    if (this.showToast) {
      this.showToast = false;
    }
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.liveTime = b + '呈现 敬请期待';
    this.showToast = true;
    this.timer = setTimeout(() => {
      this.showToast = false;
    }, 2000);
    // this.zhiboUrl[a]
  }
  showDialog(i: number) {
      window.open(this.bannerUrl[i]);
      return;
    this.dialogShow = true;
    setTimeout(() => {
      this.dialogShow = false;
    }, 1500);
    return;
    if (Date.now() - Date.parse('2021/11/08 18:35:00') > 0) {
      window.open(this.bannerUrl[i]);
      return;
    }
    if (Date.now() - Date.parse('2021/11/08 12:00:00') > 0 && i > 0) {
      window.open(this.bannerUrl[i]);
      return;
    } else {
    }
    // window.open(this.bannerUrl[i]);
  }
  toArticle(url: string) {
    console.log(url);
    // location.href = url;
    window.open(url);
  }
}
